import "vue";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
